<template>
  <v-container 
  v-if="isDataReady"
  fluid>
    <div 
    v-if="$parent.isRole(['ADMIN', 'SUPER_ADMIN', 'CLIENT'])"
    class="d-flex flex-column pb-10">
      <h4>
        {{$t('pages.partRequest.updateDataShippingDetailsTab')}}
      </h4>
    </div>
    <section-title-with-request-id
    :request-id="partRequestProp.requestId"
    title="pages.repair.contactDetails"
    class="mb-3"/>
    <v-form
    ref="form"
    v-model="isFormValid">
      <v-row dense>
        <v-col class="mr-4">
          <text-field-value 
          v-model="getAddress.companyName" 
          :disabled="disabled || $parent.isRole(['SUPERVISOR', 'SERVICE'])"
          :label="$t('textFields.companyName')"
          required/>
        </v-col>
        <v-col class="mr-4">
          <text-field-first-name 
          v-model="getContact.firstName" 
          :disabled="disabled || $parent.isRole(['SUPERVISOR', 'SERVICE'])"
          required/>
        </v-col>
        <v-col class="ml-4">
          <text-field-last-name 
          v-model="getContact.lastName" 
          :disabled="disabled || $parent.isRole(['SUPERVISOR', 'SERVICE'])"
          required/>
        </v-col>
      </v-row>
      <v-row dense class="mt-5">
        <v-col class="mr-4">
          <text-field-phone 
          v-model="getContact.phone" 
          :disabled="disabled || $parent.isRole(['SUPERVISOR', 'SERVICE'])"
          required/>
        </v-col>
        <v-col class="ml-4">
          <text-field-email
          :label="$t('textFields.email')"
          v-model="getContact.email" 
          :disabled="disabled || $parent.isRole(['SUPERVISOR', 'SERVICE'])"
          required/>
        </v-col>
      </v-row>
      <v-row v-for="(r, i) in getBackupEmailsPositions()" 
      class="mt-5"
      :key="i + 100"  
      dense 
      no-gutters >
        <v-col v-if="r.col1 && r.col1 !== 'btn'" class="mr-4">
          <text-field-email
          :label="$t('textFields.email')"
          v-model="r.col1.value"
          @click:append="disabled || $parent.isRole(['SUPERVISOR', 'SERVICE']) ? '' : removeNewBackUpEmail(r.col1)"
          required
          :disabled="disabled || $parent.isRole(['SUPERVISOR', 'SERVICE'])"
          append-icon="mdi-minus"/>
        </v-col>
        <v-col v-else-if="r.col1 && r.col1 === 'btn'" class="d-flex justify-center align-center mr-4">
          <v-btn
          :disabled="disabled || $parent.isRole(['SUPERVISOR', 'SERVICE'])"
          @click="addNewBackUpEmail"
          icon>
            <v-icon color="blue">
              mdi-plus
            </v-icon>
          </v-btn>
        </v-col>
        <v-col v-if="r.col2 && r.col2 !== 'btn'" class="ml-4">
          <text-field-email
          :label="$t('textFields.email')"
          v-model="r.col2.value"
          @click:append="disabled || $parent.isRole(['SUPERVISOR', 'SERVICE']) ? '' : removeNewBackUpEmail(r.col2)"
          append-icon="mdi-minus"
          :disabled="disabled || $parent.isRole(['SUPERVISOR', 'SERVICE'])"
          required/>
        </v-col>
        <v-col v-else-if="r.col2 && r.col2 === 'btn'" class="d-flex justify-center align-center ml-4">
          <v-btn
          :disabled="disabled || $parent.isRole(['SUPERVISOR', 'SERVICE'])"
          @click="addNewBackUpEmail"
          icon>
            <v-icon color="blue">
              mdi-plus
            </v-icon>
          </v-btn>
        </v-col>
      </v-row>
      <v-row
      v-if="getBackupEmailsPositions().length === 0">
        <v-col class="d-flex justify-center align-center ml-4">
          <v-btn
          :disabled="disabled || $parent.isRole(['SUPERVISOR', 'SERVICE'])"
          @click="addNewBackUpEmail"
          icon>
            <v-icon color="blue">
              mdi-plus
            </v-icon>
          </v-btn>
        </v-col>
      </v-row>
      <v-row dense no-gutters class="mt-10">
          <v-col>
            <p class="process-repair-tab-section-title">{{$t('pages.repair.addressDetails')}}</p>
          </v-col>
      </v-row>
      <v-row dense no-gutters>
        <v-col>
          <text-field-value 
          v-model="getAddress.country" 
          :label="$t('textFields.country')" 
          class="mr-4" 
          :disabled="disabled || $parent.isRole(['SUPERVISOR', 'SERVICE'])"
          required/>
        </v-col>
        <v-col>
          <text-field-value 
          v-model="getAddress.province" 
          :label="$t('textFields.state')" 
          class="ml-4" 
          :disabled="disabled || $parent.isRole(['SUPERVISOR', 'SERVICE'])"/>
        </v-col>
      </v-row>
      <v-row dense no-gutters class="mt-5">
        <v-col>
          <text-field-value 
          v-model="getAddress.city" 
          :label="$t('textFields.city')" 
          class="mr-4"
          :disabled="disabled || $parent.isRole(['SUPERVISOR', 'SERVICE'])"
          required/>
        </v-col>
        <v-col>
          <text-field-value 
          v-model="getAddress.postalCode" 
          :label="$t('textFields.postalCode')" 
          class="ml-4"
          :disabled="disabled || $parent.isRole(['SUPERVISOR', 'SERVICE'])"
          required/>
        </v-col>
      </v-row>
      <v-row dense no-gutters class="mt-5">
        <v-col>
          <text-field-value 
          v-model="getAddress.street" 
          :label="$t('textFields.streetDetails')" 
          class="mr-4"
          :disabled="disabled || $parent.isRole(['SUPERVISOR', 'SERVICE'])"
          required/>
        </v-col>
        <v-col>
          <text-field-value 
          v-model="getAddress.building"
          :label="$t('textFields.building')" 
          class="ml-4"
          :disabled="disabled || $parent.isRole(['SUPERVISOR', 'SERVICE'])"/>
        </v-col>
      </v-row>
      <!-- [UNCOMMENT_PACKAGES] -->
      <!-- <add-packages-list
      v-model="packagesProp"
      :disabled="disabled || $parent.isRole(['SUPERVISOR', 'SERVICE', 'SUSTAINABILITY_MANAGER'])"
      :set-default-row="$parent.isRole(['ADMIN', 'SUPER_ADMIN', 'CLIENT'])"/> -->
    </v-form>
    <v-row 
    v-if="$parent.isRole(['ADMIN', 'SUPER_ADMIN', 'CLIENT'])"
    dense 
    class="my-10">
      <v-col>
        <p class="text-center"
        style="font-weight: bold">
          {{$t('common.pressContinueWhenReady')}}
        </p>
        <process-repair-quick-btns 
        :loading.sync="isLoading"
        :config="getQuickBtnsConfig"
        on-success-repair-status-message="dialogs.messages.success.toWaitingForPickUpStep"/>
      </v-col>
    </v-row>
    <v-row>
      <v-col
      class="d-flex justify-end">
        <primary-btn
        v-if="$parent.isRole(['ADMIN', 'SUPER_ADMIN'])"
        @click="openDeleteDialog"
        color="red"
        :width="120"
        :height="45"
        :disabled="disabled"
        :loading="isLoading"
        class="mx-2"
        :label="$t('btns.delete')"/>
      </v-col>
    </v-row>
  </v-container>
</template>
<script>
import TextFieldFirstName from '@/components/text-fields/TextFieldFirstName'
import TextFieldLastName from '@/components/text-fields/TextFieldLastName'
import TextFieldPhone from '@/components/text-fields/TextFieldPhone'
import TextFieldEmail from '@/components/text-fields/TextFieldEmail'
import TextFieldValue from '@/components/text-fields/TextFieldValue'
// [UNCOMMENT_PACKAGES]
// import AddPackagesList from '@/components/common/process-tabs/shared/AddPackagesList'
import PrimaryBtn from '@/components/btns/PrimaryBtn'
import ProcessRepairQuickBtns from '@/components/process-repair-tabs/ProcessRepairQuickBtns'
import SectionTitleWithRequestId from '@/components/common/process-tabs/shared/SectionTitleWithRequestId'
import { updateOneWayShipping, deletePartRequestInShippingById } from '@/repositories/partRequestRepo'
import { execHttpRequestThrowable } from '@/services/http'
//ENABLE_CHANGE_DIALOG - This method is needed for changes dialog.
// compareObjects
import { copyObj, cloneObj } from '@/utils/StringUtil'
import { routeFromRoot } from '@/services/routeService'
export default {
  name: 'ShippingDetailsTabPartRequest',
  components: {
    TextFieldFirstName,
    TextFieldLastName,
    TextFieldPhone,
    TextFieldEmail,
    TextFieldValue,
    // [UNCOMMENT_PACKAGES]
    // AddPackagesList,
    PrimaryBtn,
    ProcessRepairQuickBtns,
    SectionTitleWithRequestId
  },
  props: {
    data: {
      type: Object,
      required: true
    },
    disabled: Boolean
  },
  data() {
    return {
      isFormValid: false,
      newData: null,
      isLoading: false,
      isDataReady: false
    }
  },
  methods: {
    async tryToSaveData() {
      const messages = {
        _200: 'dialogs.messages.success.pickUpDataSavedSuccessfully'
      }

      const r = await execHttpRequestThrowable(
        async () => await updateOneWayShipping(this.$route.params.id, this.newData.onewayShipping),
        messages,
        v => this.isLoading = v)
      cloneObj(this.newData.onewayShipping, this.partRequestProp.onewayShipping)
      this.newData.isAllowedToContinue = r.response.data
    },
    async tryToDeleteRepair() {
      const messages = {
        _200: 'dialogs.messages.success.partRequestDeletedSuccessfully'
      }

      await execHttpRequestThrowable(async () => await deletePartRequestInShippingById(this.$route.params.id), messages, v => this.isLoading = v)
      routeFromRoot('part-request/list')
    },
    openDeleteDialog() {
      this.$confirmActionDialog.open('pages.partRequest.deletePartRequest',
      null,
      'btns.delete',
      null,
      this.tryToDeleteRepair)
    },
    setChangedDialogItems() {
      this.tryToSaveData()  
      // NOTE: ENABLE_CHANGE_DIALOG - Enable this code, if changes dialog is needed.
      //-----------------------------------------------------------------
      // const old = this.partRequestProp.onewayShipping
      // const _new = this.newData.onewayShipping

      // const props = [
      //   {
      //     field: 'textFields.firstName',
      //     prop: 'contact.firstName'
      //   }, {
      //     field: 'textFields.lastName',
      //     prop: 'contact.lastName'
      //   }, {
      //     field: 'textFields.phone',
      //     prop: 'contact.phone'
      //   }, {
      //     field: 'textFields.email',
      //     prop: 'contact.email'
      //   }, {
      //     field: {
      //       value: 'textFields.backupEmailNo',
      //       params: null
      //     },
      //     prop: 'contact.backupEmails[].value'
      //   }, {
      //     field: 'textFields.companyName',
      //     prop: 'address.companyName'
      //   }, {
      //     field: 'textFields.country',
      //     prop: 'address.country'
      //   }, {
      //     field: 'textFields.state',
      //     prop: 'address.province'
      //   }, {
      //     field: 'textFields.city',
      //     prop: 'address.city'
      //   }, {
      //     field: 'textFields.postalCode',
      //     prop: 'address.postalCode'
      //   }, {
      //     field: 'textFields.street',
      //     prop: 'address.street'
      //   }, {
      //     field: 'textFields.building',
      //     prop: 'address.building'
      //   }, {
      //     field: {
      //       value: 'textFields.dimensionsNo',
      //       params: null
      //     },
      //     prop: 'packages[].dimensions'
      //   }, {
      //     field: {
      //       value: 'textFields.weightNo',
      //       params: null
      //     },
      //     prop: 'packages[].weight'
      //   }
      // ]

      // this.$changesDialog.open(
      //   'dialogs.titles.changes',
      //   compareObjects(old, _new, props),
      //   this.tryToSaveData,
      //   false
      // )
      //-----------------------------------------------------------------
    },
    addNewBackUpEmail() {
      this.getContact.backupEmails.push({
        id: null,
        value: ''
      })
    },
    removeNewBackUpEmail(e) {
      this.getContact.backupEmails = this.getContact.backupEmails.filter(be => be !== e)
    },
    getBackupEmailsPositions() {
      const rows = []
      let changeRow = true
      let i = -1
      let c = 0

      for (const be of this.getContact.backupEmails) {
        c++
        if (changeRow) {
          changeRow = false
          i++
          rows[i] = {
            col1: be,
            col2: 'btn'
          }
        }
        if (c === 2) {
          rows[i].col2 = be
          c = 0
          changeRow = true
        }
      }

      if (rows.length > 0 && rows[rows.length - 1].col2 !== 'btn') {
        rows.push({
          col1: 'btn',
          col2: null
        })
      }

      return rows
    }
  },
  computed: {
    getContact() {
      return this.newData.onewayShipping.contact
    },
    getAddress() {
      return this.newData.onewayShipping.address
    },
    // [UNCOMMENT_PACKAGES]
    // packagesProp: {
    //   get: function() {
    //     return this.newData.onewayShipping.packages
    //   },
    //   set: function(v) {
    //     this.newData.onewayShipping.packages = v
    //   }
    // },
    partRequestProp: {
      get: function() {
        return this.$props.data
      },
      set: function(v) {
        this.$emit('update:data', v)
      }
    },
    getQuickBtnsConfig() {
      return [
        {
          name: 'Save',
          events: {
            'click': this.setChangedDialogItems
          },
          props: {
            // [UNCOMMENT_PACKAGES]
            'disabled': this.disabled || !this.isFormValid //|| this.packagesProp.length === 0
          }
        }, {
          name: 'Continue',
          props: {
            'disabled': this.disabled || !this.newData.isAllowedToContinue
          }
        }
      ]
    }
  },
  mounted() {
    this.newData = {
      isAllowedToContinue: this.partRequestProp.isAllowedToContinue,
      onewayShipping: copyObj(this.partRequestProp.onewayShipping)
    }
    this.isDataReady = true
  }
}
</script>
<style>

</style>